<div class="top-bar-root">
  <div class="top-bar-left">
    <div class="issue-info" [ngStyle]="!group ? { padding: '11px 0' } : {}">
      <div class="issue-number" *ngIf="group?.name && !group?.excluded">Issue #{{ issueNo }}</div>

      <div class="issue-title">{{ group?.name || 'Uncategorized' }}</div>
    </div>
    <div class="divider" *ngIf="group?.name"></div>
    <div class="issue-details" (click)="editGroup.emit(true)" *ngIf="group?.name">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          d="M6.32478 1.66577C4.69894 1.66577 3.35645 2.8991 3.35645 4.45244V15.5458C3.35645 17.0992 4.69894 18.3325 6.32478 18.3325H13.7214C15.3473 18.3325 16.6898 17.0992 16.6898 15.5458C16.6898 15.0033 16.6898 9.04746 16.6898 7.49912C16.6898 7.49079 16.6898 7.48162 16.6898 7.47328C16.6898 4.50411 13.8239 1.66577 10.8564 1.66577C7.34478 1.66577 7.33644 1.66577 6.32478 1.66577ZM6.32478 3.33244C7.15061 3.33244 8.08478 3.33244 10.0231 3.33244V5.54579C10.0231 7.09913 11.3656 8.33246 12.9914 8.33246H15.0231C15.0231 10.4466 15.0231 15.0592 15.0231 15.5458C15.0231 16.1408 14.4614 16.6658 13.7214 16.6658H6.32478C5.58478 16.6658 5.02311 16.1408 5.02311 15.5458V4.45244C5.02311 3.85744 5.58478 3.33244 6.32478 3.33244ZM11.6898 3.43661C13.1664 3.82828 14.5364 5.19328 14.9189 6.66579H12.9914C12.2506 6.66579 11.6898 6.14079 11.6898 5.54579V3.43661ZM7.52311 6.66579C7.06311 6.66579 6.68978 7.03912 6.68978 7.49912C6.68978 7.95912 7.06311 8.33246 7.52311 8.33246H8.35645C8.81645 8.33246 9.18978 7.95912 9.18978 7.49912C9.18978 7.03912 8.81645 6.66579 8.35645 6.66579H7.52311ZM7.52311 9.99913C7.06311 9.99913 6.68978 10.3725 6.68978 10.8325C6.68978 11.2925 7.06311 11.6658 7.52311 11.6658H12.5231C12.9831 11.6658 13.3564 11.2925 13.3564 10.8325C13.3564 10.3725 12.9831 9.99913 12.5231 9.99913H7.52311ZM7.52311 13.3325C7.06311 13.3325 6.68978 13.7058 6.68978 14.1658C6.68978 14.6258 7.06311 14.9991 7.52311 14.9991H12.5231C12.9831 14.9991 13.3564 14.6258 13.3564 14.1658C13.3564 13.7058 12.9831 13.3325 12.5231 13.3325H7.52311Z"
          fill="#2F353A" />
      </svg>
      <div class="issue-details-label">Issue Details</div>
    </div>
    <div class="top-bar-right-group" *ngIf="group?.name">
      <div class="divider"></div>
      <div class="pill violation" *ngIf="group?.subtype?.type?.name == 'Violation'">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 17" fill="none">
          <path
            d="M5.99837 1.84277C4.96904 1.84277 4.13504 2.14564 3.49837 2.65531C3.19704 2.89644 2.8537 3.29244 2.7277 3.55111C2.68237 3.64411 2.66504 3.73924 2.66504 3.84277C2.66504 4.75944 2.66504 10.2594 2.66504 11.1761V14.5094C2.66504 14.8776 2.96371 15.1761 3.33171 15.1761C3.69971 15.1761 3.99837 14.8776 3.99837 14.5094L3.99703 11.3757C4.05503 11.283 4.13637 11.1866 4.33171 11.0302C4.73637 10.7066 5.27771 10.5094 5.99837 10.5094C6.36437 10.5094 6.57037 10.559 6.91504 10.6969C6.95104 10.7114 7.11971 10.7829 7.16504 10.8011C7.82171 11.0637 8.39637 11.1761 9.33171 11.1761C11.6997 11.1761 13.3317 9.54431 13.3317 7.17611C13.3317 5.91104 13.3317 4.58838 13.3317 3.84277C13.3317 2.80791 12.3664 1.84277 11.3317 1.84277C11.091 1.84277 10.8657 1.89571 10.6024 1.98864C10.461 2.03857 9.90304 2.25597 9.99837 2.21777C9.50771 2.41391 9.13771 2.50944 8.66504 2.50944C8.21171 2.50944 7.94837 2.44057 7.49837 2.23864C7.40437 2.19631 7.33503 2.17511 7.29036 2.15531C6.8177 1.94597 6.47371 1.84277 5.99837 1.84277Z"
            fill="#DC3E3E" />
        </svg>
        <div class="violation-label">Violation</div>
      </div>
      <div class="pill discrepancy" *ngIf="group?.subtype?.type?.name == 'Discrepancy'">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 17" fill="none">
          <path
            d="M5.99837 1.84277C4.96904 1.84277 4.13504 2.14564 3.49837 2.65531C3.19704 2.89644 2.8537 3.29244 2.7277 3.55111C2.68237 3.64411 2.66504 3.73924 2.66504 3.84277C2.66504 4.75944 2.66504 10.2594 2.66504 11.1761V14.5094C2.66504 14.8776 2.96371 15.1761 3.33171 15.1761C3.69971 15.1761 3.99837 14.8776 3.99837 14.5094L3.99703 11.3757C4.05503 11.283 4.13637 11.1866 4.33171 11.0302C4.73637 10.7066 5.27771 10.5094 5.99837 10.5094C6.36437 10.5094 6.57037 10.559 6.91504 10.6969C6.95104 10.7114 7.11971 10.7829 7.16504 10.8011C7.82171 11.0637 8.39637 11.1761 9.33171 11.1761C11.6997 11.1761 13.3317 9.54431 13.3317 7.17611C13.3317 5.91104 13.3317 4.58838 13.3317 3.84277C13.3317 2.80791 12.3664 1.84277 11.3317 1.84277C11.091 1.84277 10.8657 1.89571 10.6024 1.98864C10.461 2.03857 9.90304 2.25597 9.99837 2.21777C9.50771 2.41391 9.13771 2.50944 8.66504 2.50944C8.21171 2.50944 7.94837 2.44057 7.49837 2.23864C7.40437 2.19631 7.33503 2.17511 7.29036 2.15531C6.8177 1.94597 6.47371 1.84277 5.99837 1.84277Z"
            fill="#6D7275" />
        </svg>
        <div class="violation-label">Discrepancy</div>
      </div>
    </div>
  </div>
  <div class="top-bar-right">
    <div class="flag-summary-bar">
      <div
        class="flag-summary"
        [ngClass]="{
          selected: selectedTab === 'included',
          disabled: !isTabEnabled('included'),
          enabled: isTabEnabled('included')
        }"
        (click)="selectTab('included')">
        <div class="flag-summary-label flag-summary-label-grey">Included Flags</div>
        <div class="flag-summary-count flag-summary-count-brand">{{ countTabs?.included }}</div>
      </div>
      <div
        class="flag-summary"
        [ngClass]="{
          selected: selectedTab === 'toResolve',
          disabled: !isTabEnabled('toResolve'),
          enabled: isTabEnabled('toResolve')
        }"
        (click)="selectTab('toResolve')">
        <div class="flag-summary-label flag-summary-label-grey">Flags to Resolve</div>
        <div class="flag-summary-count flag-summary-count-grey">{{ countTabs?.toResolve }}</div>
      </div>
      <div
        class="flag-summary"
        [ngClass]="{
          selected: selectedTab === 'resolved',
          disabled: !isTabEnabled('resolved'),
          enabled: isTabEnabled('resolved')
        }"
        (click)="selectTab('resolved')">
        <div class="flag-summary-label flag-summary-label-grey">Resolved Flags</div>
        <div class="flag-summary-count flag-summary-count-grey">{{ countTabs?.resolved }}</div>
      </div>
      <div
        class="flag-summary"
        [ngClass]="{
          selected: selectedTab === 'excluded',
          disabled: !isTabEnabled('excluded'),
          enabled: isTabEnabled('excluded')
        }"
        (click)="selectTab('excluded')">
        <div class="flag-summary-label flag-summary-label-grey">Excluded Flags</div>
        <div class="flag-summary-count flag-summary-count-grey">{{ countTabs?.excluded }}</div>
      </div>
    </div>
    <div class="flag-summary-footer">
      <div class="last-edited">
        <div class="warning-icon-wrapper" *ngIf="hasChangesAfterLetter">
          <img src="assets/img/svg/warning-icon.svg" alt="Warning" class="warning-icon" />
          <div class="tooltip">Changes have been made since last rec letter generation.</div>
        </div>
        <span class="last-edited-label">Last edited:</span>
        <span class="last-edited-date">{{ lastEditedDate }}</span>
      </div>
      <div class="view-change-log" (click)="openIssueDetailModal()">View change log</div>
    </div>
  </div>
</div>

<app-flag-manager-issue-detail #issueDetailModal [currentFlags]="currentFlags"></app-flag-manager-issue-detail>
